<template>
  <div class="datepicker control">
    <v-date-picker v-model="computedValue" :mode="mode" :first-day-of-week="firstDayOfWeek" :masks="{input: maskedInput}">
      <template v-slot="{ inputValue, inputEvents }">
        <div class="control">
          <input type="text" :placeholder="placeholder" class="input focus:outline-none focus:border-primary-500" :value="inputValue" v-on="inputEvents">
        </div>
      </template>
    </v-date-picker>
  </div>
  <!-- <div class="datepicker control" :class="[size, {'is-expanded': expanded}]">
    <d-dropdown v-if="!isMobile || inline" ref="dropdown" :position="position" :disabled="disabled" :inline="inline" :class="{'inline': inline}">
      <d-input
        v-if="!inline"
        ref="input"
        slot="activator"
        autocomplete="off"
        :value="formatValue(dateSelected)"
        :placeholder="placeholder"
        :size="size"
        :icon="icon"
        :icon-pack="iconPack"
        :rounded="rounded"
        :loading="loading"
        :disabled="disabled"
        :readonly="!editable"
        v-bind="$attrs"
        @change.native="onChange($event.target.value)"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event) && checkHtml5Validity()"
      />

      <d-dropdown-item :disabled="disabled" custom>
        <header class="datepicker-header">
          <template v-if="$slots.header !== undefined && $slots.header.length">
            <slot name="header" />
          </template>
          <div v-else class="pagination field is-centered" :class="size">
            <a v-show="!isFirstMonth && !disabled" class="pagination-previous" role="button" href="#" :disabled="disabled" @click.prevent="decrementMonth" @keydown.enter.prevent="decrementMonth" @keydown.space.prevent="decrementMonth">
              <d-icon icon="chevron-left" pack="fas" type="is-primary is-clickable" />
            </a>
            <a v-show="!isLastMonth && !disabled" class="pagination-next" role="button" href="#" :disabled="disabled" @click.prevent="incrementMonth" @keydown.enter.prevent="incrementMonth" @keydown.space.prevent="incrementMonth">
              <d-icon icon="chevron-right" pack="fas" type="is-primary is-clickable" />
            </a>
            <div class="pagination-list flex-no-wrap">
              <d-select v-model="focusedDateData.month" :disabled="disabled" :size="size">
                <option v-for="(month, index) in monthNames" :key="month" :value="index">
                  {{ month }}
                </option>
              </d-select>
              <d-select v-model="focusedDateData.year" :disabled="disabled" :size="size">
                <option v-for="year in listOfYears" :key="year" :value="year">
                  {{ year }}
                </option>
              </d-select>
            </div>
          </div>
        </header>

        <div class="datepicker-content">
          <d-datepicker-table
            v-model="dateSelected"
            :day-names="dayNames"
            :month-names="monthNames"
            :first-day-of-week="firstDayOfWeek"
            :min-date="minDate"
            :max-date="maxDate"
            :focused="focusedDateData"
            :disabled="disabled"
            :unselectable-dates="unselectableDates"
            :unselectable-days-of-week="unselectableDaysOfWeek"
            :selectable-dates="selectableDates"
            :events="events"
            :indicators="indicators"
            :date-creator="dateCreator"
            @close="$refs.dropdown.isActive = false"
          />
        </div>

        <footer v-if="$slots.default !== undefined && $slots.default.length" class="datepicker-footer">
          <slot />
        </footer>
      </d-dropdown-item>
    </d-dropdown>

    <d-input
      v-else
      ref="input"
      type="date"
      autocomplete="off"
      :value="formatYYYYMMDD(value)"
      :placeholder="placeholder"
      :size="size"
      :icon="icon"
      :icon-pack="iconPack"
      :loading="loading"
      :max="formatYYYYMMDD(maxDate)"
      :min="formatYYYYMMDD(minDate)"
      :disabled="disabled"
      :readonly="false"
      v-bind="$attrs"
      @change.native="onChangeNativePicker"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event) && checkHtml5Validity()"
    />
  </div> -->
</template>

<script>
  import PopoverRow from 'v-calendar/lib/components/popover-row.umd.min';
  import FormElementMixin from '../../../utils/mixins/formElementMixin.js';
  import { isMobile } from '../../../utils/helpers.js';
  import DDropdown from '../DDropdown/DDropdown.vue';
  import DDropdownItem from '../DDropdown/DDropdownItem.vue';
  import DInput from '../DInput/DInput.vue';
  import DField from '../DField/DField.vue';
  import DSelect from '../DSelect/DSelect.vue';
  import DIcon from '../DIcon/DIcon.vue';
  import DDatepickerTable from './DDatepickerTable.vue';
  export default {
    name: 'DDatepicker',
    components: {
      PopoverRow, // v-calendar
      DDatepickerTable,
      DInput,
      DField,
      DSelect,
      DIcon,
      DDropdown,
      DDropdownItem,
    },
    mixins: [FormElementMixin],
    inheritAttrs: false,
    props: {
      value: [Date, String],

      /*
      * Sets the selection view
      * @parameters `date`, `dateTime`, `time`
      */
      mode: {
        type: String,
        default: 'date',
      },

      /*
      * Day number for the first day of the week (1: Sun - 7: Sat). Ignore setting this prop if you want to allow the locale to determine this setting.
      */
      firstDayOfWeek: Number,
      minDate: Date,
      maxDate: Date,
      placeholder: String,
      disabled: Boolean,
      events: Array,
    },

    computed: {
      computedValue: {
        get() {
          const timestamp = Date.parse(this.value);
          if (this.value && !isNaN(timestamp)) {
            return new Date(this.value);
          }

          return this.value;
        },
        set(value) {
          this.$emit('input', value);
          // !this.isValid && this.checkHtml5Validity();
        },
      },

      maskedInput() {
        if (this.mode === 'dateTime') {
          return 'MM/DD/YYYY h:mmA';
        }
        if (this.mode === 'time') {
          return 'h:mmA';
        }
        return 'MM/DD/YYYY';
      },
    },
  };
</script>